<script>
  export let bg_color = '#000';
  export let text_color = '#fff';
</script>

<div class="tag" style="--bg_color: {bg_color}; --text_color: {text_color};"><slot /></div>

<style lang="scss">
  .tag {
    position: absolute;
    height: 35px;
    bottom: 35px;
    right: 0;
    padding: 0 20px;
    background-color: var(--bg_color);
    border-radius: 10px 0 0 10px;
    color: var(--text_color);
    font-size: 16px;
    font-weight: 600;
    line-height: 35px;
    text-align: center;
  }
</style>
